import { Box, ThemeProvider } from '@material-ui/core';
import globalMaterialUITheme from '@alo/yoga-ui';
import React, { useState } from 'react';
import styles from './style.module.scss';
import ReactDOM from 'react-dom';
import ReshopMessaging from 'src/scripts/templates/_shared/Reshop';
import { isDevShop } from 'src/scripts/utils/environment';

const DomesticReturnsAndExchangesPage = () => {
  const {
    returnSelectionHeadline,
    returnSelectionReturnCTA,
    returnSelectionExchangeCTA,
    returnSelectionReturnandExchangeCTA,
    returnTypeHeadline,
    returnTypeOption1Header,
    returnTypeOption1CTA,
    returnTypeOption1BodyText,
    returnTypeOption1ButtonCTA,
    returnTypeOption2Header,
    returnTypeOption2CTA,
    returnTypeOption2BodyText,
    returnTypeOption2ButtonCTA,
    returnDirectionalInfo,
  } = window.getSiteSettings().reshop;
  // if the user has made it to the returns selection screen, we want to persist that so they don't have to start over (product decision)
  const [page, setPage] = useState(localStorage.getItem('domesticReturnsAndExchangesPage') || 'selection');
  const queryParams = new URLSearchParams(window.location.search);
  const order = queryParams.get('order');
  const email = queryParams.get('email');

  let queryString = '';
  if (order) queryString += `order=${encodeURIComponent(order)}&`;
  if (email) queryString += `email=${encodeURIComponent(email)}&`;

  const loopReturnsLink = isDevShop
    ? `https://dev2aloyoga.loopreturns.com/${queryString ? `?${queryString}` : ''}`
    : `https://returns.aloyoga.com/#/${queryString ? `?${queryString}` : ''}`;

  const reshopLink = isDevShop
    ? 'https://returns.reshop.com/dev2aloyoga'
    : 'https://returns.reshop.com/Alo-Yoga?utm_source=AloYogaReturnSite';

  const backButton = () => {
    setPage('selection');
    localStorage.removeItem('domesticReturnsAndExchangesPage');
  };

  const goToReturnsOptions = () => {
    setPage('return');
    localStorage.setItem('domesticReturnsAndExchangesPage', 'return');
  };

  const renderPage = () => {
    switch (page) {
      case 'selection':
        return (
          <>
            <h2 className="h2 uppercase">{returnSelectionHeadline}</h2>
            <Box className={`${styles.returnOptionButtons} d-flex flex-column`}>
              <button className="button-ghost" onClick={goToReturnsOptions}>
                {returnSelectionReturnCTA}
              </button>
              <a className="button-ghost link-styled-as-button" href={loopReturnsLink} target="_blank" rel="noreferrer">
                {returnSelectionExchangeCTA}
              </a>
              <a className="button-ghost link-styled-as-button" href={loopReturnsLink} target="_blank" rel="noreferrer">
                {returnSelectionReturnandExchangeCTA}
              </a>
            </Box>
          </>
        );
      case 'return':
        return (
          <>
            <button className={`${styles.backButton} d-flex lowercase-button`} onClick={backButton}>
              <span className="alo-thick-arrow-left-icon"></span> Back
            </button>
            <h2 className="h2 uppercase">{returnTypeHeadline}</h2>
            <Box className={`${styles.optionsBoxes} d-flex`}>
              <Box p={3} className={`${styles.optionsBoxes__option} d-flex flex-column`}>
                <h6 className="h6 uppercase">{returnTypeOption1Header}</h6>
                <h4 className="h4 uppercase">{returnTypeOption1CTA}</h4>
                <p className="body">{returnTypeOption1BodyText}</p>
                <a
                  className="button-primary-sm link-styled-as-button"
                  href={loopReturnsLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  {returnTypeOption1ButtonCTA}
                </a>
              </Box>
              <Box p={3} className={`${styles.optionsBoxes__option} d-flex flex-column`}>
                <h6 className="h6 uppercase">{returnTypeOption2Header}</h6>
                <h4 className="h4 uppercase">
                  {returnTypeOption2CTA} <ReshopMessaging location="returnsPage" />
                </h4>
                <p className="body">{returnTypeOption2BodyText}</p>
                <a
                  className="button-primary-sm link-styled-as-button"
                  href={reshopLink}
                  target="_blank"
                  rel="noreferrer"
                >
                  {returnTypeOption2ButtonCTA}
                </a>
              </Box>
            </Box>
          </>
        );
      default:
        return null;
    }
  };

  return (
    <ThemeProvider theme={globalMaterialUITheme}>
      <Box
        id={page === 'selection' ? `DomesticReturnsAndExchangesPage` : `ReturnSelectionPage`}
        className={`${styles.pageContainer} text-center d-flex flex-column`}
        p={2}
      >
        {renderPage()}
        <div className={`body ${styles.contactLink}`}>
          <div dangerouslySetInnerHTML={{ __html: returnDirectionalInfo }} />
        </div>
      </Box>
    </ThemeProvider>
  );
};

export default DomesticReturnsAndExchangesPage;

const mountNode = document.querySelector('[react-render-target="domestic-returns-and-exchanges-page"]');
mountNode
  ? ReactDOM.render(<DomesticReturnsAndExchangesPage />, mountNode)
  : console.warn('missing render target: DomesticReturnsAndExchangesPage');
